export var ACTION;
(function (ACTION) {
    ACTION["TRANSACTION"] = "TRANSACTION";
    ACTION["NAVIGATION"] = "NAVIGATION";
    ACTION["EMAIL"] = "EMAIL";
    ACTION["MENU"] = "MENU";
})(ACTION || (ACTION = {}));
